import { render, staticRenderFns } from "./CategoryEditDialog.vue?vue&type=template&id=68821c9a"
import script from "./CategoryEditDialog.vue?vue&type=script&lang=js"
export * from "./CategoryEditDialog.vue?vue&type=script&lang=js"
import style0 from "./CategoryEditDialog.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports